// TODO move fetching from component to page
// eslint-disable-next-line internal-rules/no-restricted-prefetch-imports
import { withPrefetchedData } from '#src/shared/prefetch';

import { MembershipBottomBanner as Layout } from './component';
import type { MembershipBottomBannerPrefetchedDataProps } from './context';
import { MembershipBottomBannerContextProvider, prefetchContext } from './context';
import type { Props } from './shared/types';

type MembershipBottomBannerProps = MembershipBottomBannerPrefetchedDataProps & Props;

export const MembershipBottomBanner = withPrefetchedData(
	function MembershipBottomBannerEntry({ prefetchedData, ...layoutProps }: MembershipBottomBannerProps) {
		return (
			<MembershipBottomBannerContextProvider prefetchedData={prefetchedData}>
				<Layout {...layoutProps} />
			</MembershipBottomBannerContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchContext(context),
	},
);
